import { ProfileData } from '../types';
import { userAData } from './userA';

// Dynamic content data based on domain - lazy loaded to avoid SSR issues
let _contentData: ProfileData | null = null;

export const getContentData = (): ProfileData => {
  if (_contentData === null) {
    // Lazy import to avoid SSR issues
    if (typeof window !== 'undefined') {
      const { getUserDataByDomain } = require('../utils/domainUtils');
      _contentData = getUserDataByDomain();
    } else {
      _contentData = userAData; // Default for SSR
    }
  }
  return _contentData!; // We know it's not null at this point
};

// For compatibility - always use userAData during build to avoid window access
export const contentData: ProfileData = userAData;

// Legacy export for backward compatibility
export const staticContentData: ProfileData = {
  profile: {
    title: "Dating Profile - Cosmos Style",
    name: "Nagpal",
    searchPlaceholder: "Let's plan our church street date?"
  },
  photos: [
    {
      url: "/assets/WhatsApp Image 2025-07-25 at 13.40.04.jpeg",
      alt: "Profile photo 1",
      gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
    },
    {
      url: "/assets/WhatsApp Image 2025-07-25 at 13.40.04 (1).jpeg",
      alt: "Profile photo 2",
      gradient: "linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)"
    },
    {
      url: "/assets/WhatsApp Image 2025-07-25 at 13.40.05.jpeg",
      alt: "Profile photo 3",
      gradient: "linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)"
    },
    {
      url: "/assets/WhatsApp Image 2025-07-25 at 13.40.05 (1).jpeg",
      alt: "Profile photo 4",
      gradient: "linear-gradient(135deg, #d299c2 0%, #fef9d7 100%)"
    },
    {
      url: "/assets/WhatsApp Image 2025-07-25 at 13.40.05 (2).jpeg",
      alt: "Profile photo 5",
      gradient: "linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%)"
    },
    {
      url: "/assets/WhatsApp Image 2025-07-25 at 13.40.06.jpeg",
      alt: "Profile photo 6",
      gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
    }
  ],
  cards: [
    {
      id: "numbers",
      type: "numbers",
      title: "Numbers",
      items: [
        { label: "IG Followers", value: "2,347" },
        { label: "LinkedIn Followers", value: "847" },
        { label: "Twitter Followers", value: "1,203" },
        { label: "RoadSide Followers", value: "23" }
      ],
      special: {
        label: "Human Number",
        value: "#4,284,719,358"
      }
    },
    {
      id: "interactions",
      type: "interactions",
      title: "App Interactions of the past 7 days?",
      subtitle: "Some cool things."
    },
    {
      id: "book",
      type: "image",
      title: "Physics & Microphysics",
      content: "📚 Physics & Microphysics",
      height: "200px",
      background: "linear-gradient(135deg, #8bc34a, #4caf50)",
      fontSize: "24px"
    },
    {
      id: "spotify",
      type: "embed",
      embedType: "spotify",
      icon: "🎵",
      title: "Currently Playing",
      subtitle: "Lofi Hip Hop Mix",
      service: "Spotify Embed"
    },
    {
      id: "weekend-quote",
      type: "quote",
      title: "\"His Last Weekend\"",
      quote: "Saturday morning coffee at the local café, watching people rush by while I sat still. Sunday afternoon hiking trail, where the only sound was my breathing and distant birds. That perfect balance of solitude and connection with the world.",
      author: "Last weekend reflections"
    },
    {
      id: "maps",
      type: "embed",
      embedType: "map",
      icon: "🗺️",
      title: "Connecting the world",
      subtitle: "China • California • Bangalore",
      service: "Apple Maps"
    },
    {
      id: "netflix",
      type: "embed",
      embedType: "netflix",
      icon: "📺",
      title: "What did you watch?",
      subtitle: "Recently on Netflix",
      service: "Netflix Embed"
    },
    {
      id: "sculpture",
      type: "image",
      content: "🗿",
      height: "280px",
      background: "linear-gradient(135deg, #e0e0e0, #bdbdbd)",
      fontSize: "48px"
    },
    {
      id: "art",
      type: "simple",
      title: "Art",
      text: "Contemporary expressions and creative discoveries"
    },
    {
      id: "goodreads",
      type: "embed",
      embedType: "goodreads",
      icon: "📖",
      title: "Books & Bookmarks",
      subtitle: "from book recommendations",
      service: "Goodreads Embed"
    },
    {
      id: "prime",
      type: "embed",
      embedType: "prime",
      icon: "🎬",
      title: "Prime Video",
      subtitle: "Latest watchlist additions",
      service: "Prime Video Embed"
    },
    {
      id: "work",
      type: "simple",
      title: "School & Bits from Work",
      text: "Academic projects and professional insights"
    },
    {
      id: "creativity-quote",
      type: "quote",
      quote: "Creativity is not a competition.",
      author: "Philosophy"
    },
    {
      id: "android",
      type: "simple",
      title: "Android Connections",
      subtitle: "Digital interactions and smart integrations"
    }
  ]
};